const hostname = window.location.hostname;
let APP_URL = window.origin;
if (!APP_URL) {
    APP_URL = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}
// alert(APP_URL);

const hostnames = {
    'admin.capture672.com': {
        APP_URL,
        signupClass: 'capture672',
        client: 'capture672',
        singleSignOn: {
            provider: 'azure',
            active: true,
            clientID: 'd9a81b59-da83-490a-9688-13189e8e658b',
            objectID: '97c8c142-920d-44f3-bdb1-714bb0674fdf',
            tenantID: '246fe7a3-f7a9-4120-a335-2446bea2473a',
        }
    },
    'admin-test.capture672.com': {
        APP_URL,
        signupClass: 'capture672',
        client: 'capture672-test',
        singleSignOn: {
            provider: 'azure',
            active: true,
            clientID: ' e0f028da-0e1d-4891-be95-ce09faaf8d92',
            objectID: 'db28b0e2-a2ed-4f3e-ba74-a966400e7b9b',
            tenantID: '246fe7a3-f7a9-4120-a335-2446bea2473a',
        }
    },
    'localhost': {
        APP_URL,
        // signupClass: 'capture672',
        signupClass: 'localhost',
        client: 'localhost',
        singleSignOn: {
            provider: 'azure',
            active: false,
            clientID: 'fb881baa-5b47-4751-a59f-3a2304d224be',
            objectID: 'b1f6c088-de1a-4c07-b023-c115a2c7ab5d',
            tenantID: '246fe7a3-f7a9-4120-a335-2446bea2473a',
        }
    },
    'admin.legalworkflow365.com': {
        signupClass: 'legaldocflow',
        client: 'legaldocflow'
    },
    'app-pay.taybull.com': {
        APP_URL,
        signupClass: 'localhost',
        client: 'localhost',
    },
    'admin-pay.taybull.com': {
        APP_URL,
        // signupClass: 'capture672',
        signupClass: 'localhost',
        client: 'localhost',
    },
};


export const isSingleSignOnActive = () => {
    try {
        return hostnames[hostname].singleSignOn.active;
    } catch (error) {
        //
    }
    return false;
};

export const getSingleSignOn = (key) => {
    try {
        return hostnames[hostname].singleSignOn[key];
    } catch (error) {
        //
    }
    return null;
};

export const get = (key) => {
    try {
        return hostnames[hostname][key];
    } catch (error) {
        //
    }
    return null;
};

// export default {
//     get,
//     isSingleSignOnActive,
//     getSingleSignOn,
// }